angular.module('unergie.main')
.controller('consumptionDriftReportsCtrl', ($scope, $state, ApiUser, AlertManager, TableGeneratorService, ModalService, DownloadService, BoFeaturesService, ErrorCatcher, organizations) => {
    $scope.consumptionDriftReportsTypes = {
        C5: 'C5',
        // C2C4: 'C2/C4',
    }

    const canLaunchConsumptionDriftReportsDuringBillingWindow = BoFeaturesService.isFeatureOn('canLaunchConsumptionDriftReportsDuringBillingWindow')

    const billingWindowStartDay = 5
    const billingWindowEndDay = 15
    $scope.cantLaunchMessage = `La (ré)génération d'analyse est fermée pendant la période de génération des factures (${billingWindowStartDay} au ${billingWindowEndDay} du mois)`
    $scope.canLaunchConsumptionDriftReports = (moment().date() < billingWindowStartDay || moment().date() > billingWindowEndDay || canLaunchConsumptionDriftReportsDuringBillingWindow)

    $scope.consumptionDriftReports = {
        refreshing: false,
        show: {},
        counts: [10, 25, 50, 100],
        columns: {
            'id': { label: 'Id', mode: 'search_operator', mandatory: true },
            'pdf_path': { label: 'PDF', mode: 'search_wildcard' },
            'status': { label: 'Statut', mode: 'search_wildcard' },
            'type': { label: 'Type', mode: 'search_wildcard' },
            'organization': { label: 'Organisation', mode: 'search_wildcard' },
            'id_account': { label: 'Id compte', mode: 'hidden' },
            'account.brand': { label: 'Compte', mode: 'search_wildcard' },
            'start_date': { label: 'Date début', mode: 'search_date' },
            'end_date': { label: 'Date fin', mode: 'search_date' },
            'error': { label: 'Id', mode: 'search_wildcard' },
            'creation_ts': { label: 'Création', mode: 'search_date' },
        },
    }

    $scope.refresh = () => {
        TableGeneratorService.getTable($scope.consumptionDriftReports, 'consumption-drift-reports', null, null, { orderBy: '-creation_ts' })
    }

    $scope.openCreateConsumptionDriftReportModal = () => {
        ModalService.openModal({ type: 'createConsumptionDriftReportModal', size: 'lg' }, null, $scope.refresh)
    }

    $scope.shootFields = {
        to: {
            label: `Destinataire`,
            type: 'email',
            required: true,
        },
    }

    $scope.shootTemplate = {
        to: '',
    }

    $scope.shoot = (consumptionDriftReport) => {
        consumptionDriftReport.sending = true
        return ApiUser.sendConsumptionDriftReport({ id: consumptionDriftReport.id }, $scope.shootTemplate).$promise.then((result) => {
            AlertManager.success(`Analyse de consommation envoyé à ${$scope.shootTemplate.to}`, 6000)
        })
        .catch(ErrorCatcher)
        .finally(() => {
            consumptionDriftReport.sending = false
        })
    }

    $scope.regenFields = {
        overrideWaitFor: {
            label: `Modifier le délai de création de l'analyse : permet de mettre à jour les analyses dont les graphiques sont incomplets car trop lourds `
                + `(commencer par 10 secondes, puis ajouter de 10 en 10 si des graphiques sont toujours incomplets).`,
            type: 'checkbox',
        },
        waitFor: {
            hidden: (t) => !t.overrideWaitFor,
            required: true,
            label: `Délai (en sec)`,
            type: 'number',
            max: 300,
        },
    }

    $scope.regenTemplate = {
        overrideWaitFor: false,
        waitFor: 10,
    }

    $scope.regenerate = (consumptionDriftReport) => {
        consumptionDriftReport.regenerating = true
        const params = { id: consumptionDriftReport.id }
        if ($scope.regenTemplate.overrideWaitFor) {
            params.waitFor = $scope.regenTemplate.waitFor * 1000
        }
        return ApiUser.regenerateConsumptionDriftReport(params, {}).$promise.then((result) => {
            AlertManager.success(`Régénération lancée, vous recevrez un email lorsqu'elle sera terminée.`)
            $scope.refresh()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            consumptionDriftReport.regenerating = false
        })
    }

    $scope.refresh()
})
